import Button from 'components/Button';
import {set} from 'date-fns';
import {toZonedTime} from 'date-fns-tz';
import {useContext} from 'react';
import {c} from 'ttag';
import {JST_TIMEZONE} from 'utils/date';

import DateSelectContext from '../../context';
import {getSafeDate} from '../../utils';

const ButtonToday = () => {
    const {onChangeZonedAtJst, valueZonedAtJst} = useContext(DateSelectContext);

    const onClick = () => {
        const now = new Date();
        const nowInJst = toZonedTime(now, JST_TIMEZONE);

        onChangeZonedAtJst(
            valueZonedAtJst
                ? set(nowInJst, {
                      hours: valueZonedAtJst.getHours(),
                      milliseconds: 0,
                      minutes: valueZonedAtJst.getMinutes(),
                      seconds: 0,
                  })
                : getSafeDate(nowInJst),
        );
    };

    return (
        <Button
            className="w-full border-solid"
            kind="secondary"
            onClick={onClick}
            size="sm"
        >
            {c('component').t`Today`}
        </Button>
    );
};

export default ButtonToday;
